import * as tslib_1 from "tslib";
import * as React from 'react';
import store from '../store/store';
import strings from 'owa-strings/owa-options-strings';
import { format } from 'owa-strings';
import { getIconClassName } from '@uifabric/styling/lib/index';
import getAccountInformation from '../actions/getAccountInformation';
var styles = require('./StorageOptionFull.scss');
var classNames = require('classnames/bind').bind(styles);
var KB = 1024;
var MB = KB * 1024;
var GB = MB * 1024;
var StorageOptionFull = /** @class */ (function (_super) {
    tslib_1.__extends(StorageOptionFull, _super);
    function StorageOptionFull(props) {
        var _this = _super.call(this, props) || this;
        _this.getFormattedTextBasedOnSize = function (sizeInBytes, stringToFormat) {
            var numberFormat = sizeInBytes >= GB ? GB : sizeInBytes >= MB ? MB : KB;
            var numberUnitString = sizeInBytes >= GB
                ? strings.options_mailboxCleanup_GB
                : sizeInBytes >= MB
                    ? strings.options_mailboxCleanup_MB
                    : strings.options_mailboxCleanup_KB;
            return format(stringToFormat, (sizeInBytes / numberFormat).toFixed(2), numberUnitString);
        };
        getAccountInformation();
        return _this;
    }
    StorageOptionFull.prototype.render = function () {
        var isExceededQuota = !store.sendQuota.IsUnlimited && store.usageInBytes >= store.sendQuota.Value;
        var progressBarStyle = { width: store.usagePercentage + '%' };
        var storageUsedString;
        // Premium option has different description text
        if (this.props.isPremium) {
            storageUsedString = format(strings.options_premium_StorageContent, (store.sendReceiveQuota.Value / GB).toFixed(2), (store.usageInBytes / GB).toFixed(2));
        }
        else {
            var amountUsed = this.getFormattedTextBasedOnSize(store.usageInBytes, strings.options_mailboxCleanup_Used);
            var ofMaxAmount = store.sendReceiveQuota.IsUnlimited
                ? strings.options_mailboxCleanup_ofUnlimited
                : this.getFormattedTextBasedOnSize(store.sendReceiveQuota.Value, strings.options_mailboxCleanup_Max);
            storageUsedString = amountUsed + ofMaxAmount;
        }
        return (React.createElement("div", null,
            React.createElement("span", { className: styles.progressText }, storageUsedString),
            React.createElement("div", { className: styles.usageContainer },
                React.createElement("div", { className: classNames(styles.mailboxStorageUsed, isExceededQuota && styles.exceededQuota), style: progressBarStyle })),
            isExceededQuota && (React.createElement("div", { className: styles.warningText },
                React.createElement("div", { className: classNames(getIconClassName("Warning" /* Warning */), styles.icon) }),
                React.createElement("span", null, this.getFormattedTextBasedOnSize(store.usageInBytes - store.sendQuota.Value, strings.options_mailboxCleanup_AmountToUseMailbox))))));
    };
    return StorageOptionFull;
}(React.Component));
export default StorageOptionFull;
//# sourceMappingURL=StorageOptionFull.js.map